module.exports = __webpack_public_path__ + "static/media/totem.28fea4bf.png";